{
  "start": {
    "wallet": 3000,
    "station": "hub",
    "ship": "kestrel",
    "fitted": {
      "weapon1": "pdc.mk1",
      "weapon2": "laser.mk1",
      "miningLaser": "mining.mk1",
      "salvageBeam": "salvage.mk1",
      "cargo": "cargo.mk1",
      "shield": "shield.mk1",
      "power": "power.mk1",
      "thrusters": "thrusters.mk1",
      "scanner": "scanner.mk1"
    },
    "standings": { "authority": 0, "tethys": 0, "meridian": 0, "varro_security": 0, "mutual": 0, "holdfast": 0, "raider": -100 }
  },
  "repairPerHull": 30,
  "torpedoPrice": 800,
  "ship": { "frame": "KT-3", "serial": "T-0388", "registration": "RG-2291-K" },
  "goods": { "tradeEnabled": true },
  "berth": {
    "componentCapPerStation": 64,
    "componentCapTotal": 512,
    "relocateDelayDays": 3,
    "remotePull": { "jumps": 2, "unlock": { "module": "cargo.mk3", "faction": "mutual", "standing": 25 } }
  },
  "rushSpares": { "base": 1500, "premium": 1.5, "standingGain": 1 },
  "snapshotHz": 10,
  "deathRespawnSeconds": 3,
  "save": {
    "manualSlots": 3,
    "autoSlots": 3,
    "autosaveSeconds": 120,
    "maxBytes": 98304,
    "dbName": "eclipse",
    "store": "saves",
    "localStorageKey": "eclipse.saves.v1"
  }
}
